/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AncillaryDistributionCarrierBySupplierFilter,
    AncillaryDistributionCarrierBySupplierFilterFromJSON,
    AncillaryDistributionCarrierBySupplierFilterToJSON,
    GuidIdCodeAndLabelAutocompleteResult,
    GuidIdCodeAndLabelAutocompleteResultFromJSON,
    GuidIdCodeAndLabelAutocompleteResultToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

export interface ApiAncillaryDistributionCarrierBySupplierAutocompletePostRequest {
    ancillaryDistributionCarrierBySupplierFilter?: AncillaryDistributionCarrierBySupplierFilter;
}

/**
 * no description
 */
export class AncillaryDistributionCarrierBySupplierAutocompleteApi extends runtime.BaseAPI {

    /**
     */
    async apiAncillaryDistributionCarrierBySupplierAutocompletePostRaw(requestParameters: ApiAncillaryDistributionCarrierBySupplierAutocompletePostRequest): Promise<runtime.ApiResponse<GuidIdCodeAndLabelAutocompleteResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AncillaryDistributionCarrierBySupplierAutocomplete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AncillaryDistributionCarrierBySupplierFilterToJSON(requestParameters.ancillaryDistributionCarrierBySupplierFilter),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GuidIdCodeAndLabelAutocompleteResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAncillaryDistributionCarrierBySupplierAutocompletePost(requestParameters: ApiAncillaryDistributionCarrierBySupplierAutocompletePostRequest): Promise<GuidIdCodeAndLabelAutocompleteResult> {
        const response = await this.apiAncillaryDistributionCarrierBySupplierAutocompletePostRaw(requestParameters);
        return await response.value();
    }

}
